import { type CellContext } from '@tanstack/react-table';

import { type DataTableColumnHeaderMeta } from 'src/registry/components/table/types';
import { storage } from 'src/registry/utils/storage';

interface CellDateProps<TData, TValue> extends CellContext<TData, TValue> {
    dateTimeFormatOptions?: Intl.DateTimeFormatOptions;
}

/*
 * This is a cell renderer for a date value in a common format in the table.
 * Format is: MM/DD/YYYY
 */
export default function CellDate<TData, TValue>({ column, cell, dateTimeFormatOptions }: CellDateProps<TData, TValue>) {
    // We want to format the date if there is one in the cell
    const date = cell.getValue();
    const options =
        dateTimeFormatOptions ??
        (column.columnDef.meta as DataTableColumnHeaderMeta<TData, TValue>)?.dateTimeFormatOptions;
    const formattedDate = date ? new Date(date as string).toLocaleDateString(storage.getLanguage(), options) : '';

    return <span className="whitespace-nowrap">{formattedDate}</span>;
}
